// Module
var code = "<script id=\"wcc-components-wcc-heatmap-offset-viewer\" type=\"text/template\">\r\n    <div class=\"wcc-heatmap__offset-viewer__frame__inner\">\r\n        <div class=\"wcc-heatmap__offset-viewer__frame\" data-bind=\"dom: frameNode\"></div>\r\n    </div>\r\n</script>";
// Exports
module.exports = code;